import { ParagraphItem } from '@/components/AudioTextHighlight/type'

export namespace IAsrApi {
  export interface IDomainOption {
    desc: string
    name: string
    property: string
  }

  export enum recordTypeEnum  {
    // 实时
    Realtime = 1,
    // 离线
    Offline
  }
  export const recordTypeMap = {
    [recordTypeEnum.Realtime]: '实时',
    [recordTypeEnum.Offline]: '离线',
  }

  export enum taskStatusEnum {
    Loading,  // 待识别
    Working,  // 识别中
    Doing, // 处理中
    Done,  // 识别完成
    Fail,  // 识别失败
  }
  interface ITaskStateMap {
    label: string
    icon: string
  }
  export const taskStateMap: Record<taskStatusEnum, ITaskStateMap> = {
    [taskStatusEnum.Loading]: {
      label: '待识别',
      icon: 'icon_task_waiting'
    },
    [taskStatusEnum.Working]: {
      label: '识别中',
      icon: 'icon_task_working'
    },
    [taskStatusEnum.Doing]: {
      label: '处理中',
      icon: 'icon_task_working'
    },
    [taskStatusEnum.Done]: {
      label: '识别完成',
      icon: 'icon_task_success'
    },
    [taskStatusEnum.Fail]: {
      label: '识别失败',
      icon: 'icon_task_fail'
    },
  }

  export interface IListItem {
    id: string,
    name: string,
    createDt: string,
    recordType: recordTypeEnum,
    status: taskStatusEnum,
    progress: number
  }

  export interface IAsrSaveReq {
    recordId: string
    name?: string // 任务名
    save: boolean // 是否保存
  }

  export interface ASRDetail {
    createDt: string // 创建时间
    id: number // 主键id
    name: string // 记录名称
    propertyName: string // 音色名称
    audioPath: string // asr结果存储路径
    paragraphList: ParagraphItem[], // 分段信息
  }

  export enum EnumExportType {
    All = 'all',
    Audio = 'audio',
    Docx = 'docx'
  }

  export interface IProgressRes {
    id: string
    status: taskStatusEnum
    progress: number
  }
}
